import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../core/shared.service';
import { LoggingService } from '../services/logging.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-qr-validate',
  templateUrl: './qr-validate.component.html',
  styleUrl: './qr-validate.component.scss'
})
export class QrValidateComponent implements OnInit, OnDestroy {
  isToday: boolean;
  qrDate: string;

  constructor(private route: ActivatedRoute, private router: Router,
    private sharedService: SharedService,
    private loggingService: LoggingService,
    private location: Location
  ) {
  }

  ngOnInit(): void {
    try {
      const qr = Number(this.route.snapshot.queryParamMap.get('qr'));
      const siteId = this.route.snapshot.queryParamMap.get('siteId');
      const buyerName = this.route.snapshot.queryParamMap.get('buyerName');
      const branchName = this.route.snapshot.queryParamMap.get('branchName');
      if (!qr) {
        this.isToday = false;
        return;
      }
      this.location.replaceState('');
      this.qrDate = new Date(qr).toISOString().split('T')[0];
      this.loggingService.logInfo(`QR scan -  navigated: ${this.router.navigated}`);
      const today = new Date().toISOString().split('T')[0];
      this.isToday = this.qrDate === today;
      this.sharedService.markAsInternal();
      this.router.navigate(['/check-in'], {
        state: { siteId: siteId, buyerName: buyerName, branchName: branchName, qrData: qr, isToday: this.isToday }
      });
    } catch (e) {
      this.isToday = false;
      this.loggingService.logError(e);
    }
  }

  ngOnDestroy(): void {
    this.sharedService.reset();
  }
}
